/**
 * Получает значение cookie по имени
 * @param {string} name - Имя cookie
 * @returns {string|null} - Значение cookie или null, если не найдена
 */
export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

/**
 * Удаляет cookie
 * @param {string} name - Имя cookie
 * @param {object} options - Опции (path, domain), если при установке использовались
 */
export function deleteCookie(name, options = {}) {
  let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT`;

  if (options.path) {
    cookieString += `; path=${options.path}`;
  }
  if (options.domain) {
    cookieString += `; domain=${options.domain}`;
  }

  document.cookie = cookieString;
}
